import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Ragione sociale",
          text: "Ragione sociale"
        })
      ]),
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.localValue.fiscalData.companyName
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Numero partita iva",
          text: "Numero partita iva"
        })
      ]),
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.localValue.fiscalData.vatNumber
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Codice destinatario",
          text: "Codice destinatario"
        })
      ]),
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.localValue.fiscalData.codiceDestinatario
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Indirizzo pec",
          text: "Indirizzo pec"
        })
      ]),
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        value: _ctx.localValue.fiscalData.pec
      }, null, 8, _hoisted_8)
    ])
  ]))
}